<template>
  <div>
    <UlSelect
      :id="`inputGender_${formName}`"
      v-model="$v.sex.$model"
      :disabled="disabled"
      :error-message="errorMessage"
      :label="$t('preventionForm.gender.title')"
      :menu-props="{ offsetOverflow: false }"
      :options="genderList"
      :placeholder="$t('preventionForm.gender.selectGender')"
      hide-details="auto"
      @focus="sendGtmEvent('Pohlaví')"
    >
      <template #optionTitle="{ item }">
        {{ getLocaleText(item.value) }}
      </template>
    </UlSelect>
  </div>
</template>

<script>
import formValidation from '@/mixins/formValidation';
import { required } from 'vuelidate/lib/validators';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'Sex',
  mixins: [formValidation, formGtm],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    eventSufix: {
      type: String,
      default: ''
    }
  },
  validations() {
    if (this.required) {
      return {
        sex: { required }
      };
    }

    return { sex: {} };
  },
  computed: {
    sex: {
      get() {
        return this.$store.state.forms.sex.sex;
      },
      set(value) {
        this.$store.commit('forms/sex/updateSex', value);
      }
    },
    errorMessage() {
      return this.$v.sex.$error ? this.$t('preventionForm.gender.selectGender') : null;
    }
  },
  created() {
    this.$eventHub.$on(`validateSex${this.eventSufix}`, done =>
      this.validateForm(done, 'forms/sex')
    );
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateSex${this.eventSufix}`);
  }
};
</script>
